import {
  UPDATE_KLINES,
  UPDATE_GAME,
  UPDATE_CUP,
  UPDATE_CUP_PLAYER,
  UPDATE_NEXT_TRADING_DAY,
  UPDATE_PLAYER,
  UPDATE_GAMES,
  UPDATE_PLAY_CUP_ID,
  UPDATE_PLAY_GAME_ID,
  UPDATE_PLAY_KLINES,
  UPDATE_MY_RANK,
  UPDATE_REALITY_RANKS,
  UPDATE_USERS
} from '../../../mutation-types'
import {
  array2map, forIn
} from '../../../../common/utils';

export default {
  //更新当前K线信息
  [UPDATE_KLINES](state, info) {
    const {
      cupId,
      kid,
      klines
    } = info

    if (state.cupId === cupId) {
      state.kid = kid || 0
      state.klines = klines || []
    }
  },

  //更新局信息
  [UPDATE_GAME](state, gameInfo) {
    const {
      gameId
    } = gameInfo

    // TODO: 是否要校验是否为同一 cupId ?
    if (gameId > 0) {
      const gamesMap = state.gamesMap || {}
      gamesMap[gameId] = gameInfo
      // alert([state.cupId, cupId])
      // if (state.cupId == cupId) {
      //   state.uid = uid
      //   state.gameId = gameId
      //   state.cupId = cupId
      //   state.gameInfo = gameInfo
      // }

      state.gamesMap = gamesMap
    }


    // console.log(JSON.stringify({
    //   gameId,
    //   cupId,
    //   uid
    // }))
  },

  [UPDATE_GAMES](state, gameInfoList) {
    state.gamesList = gameInfoList
    state.gamesMap = array2map(gameInfoList, 'gameId')
    // state.gamesMap = assign({}, state.gamesMap, array2map(gameInfoList, 'gameId'))
  },

  // 擂台信息
  [UPDATE_CUP](state, cup) {
    const cupsMap = state.cupsMap || {}
    if (cup) {
      cupsMap[cup.cupId] = cup
      // state.cupId = cup.cupId
      // state.cupInfo = cup
      // state.nextTradingDay = nextTradingDay
      // } else {
      //   state.cupId = 0
      //   state.cupInfo = null
      // state.nextTradingDay = ''
    }
    state.cupsMap = cupsMap
  },

  [UPDATE_CUP_PLAYER](state, info) {
    if (info) {
      state._cupPlayer = info
    } else {
      state._cupPlayer = null
    }
  },

  [UPDATE_PLAYER](state, player) {
    state.player = player
  },

  [UPDATE_NEXT_TRADING_DAY](state, {
    nextTradingDay
  }) {
    state.nextTradingDay = nextTradingDay
  },

  [UPDATE_PLAY_CUP_ID](state, {
    cupId
  }) {
    const playInfo = state.playInfo
    if(!playInfo || playInfo.cupId !== cupId) {// 重置
      state.playInfo = {
        cupId,
        gameId: 0,
        kid:0,
        uid:0,
        klines: null
      }
    }
  },
  [UPDATE_PLAY_GAME_ID](state, {
    cupId,
    gameId
  }) {
    const playInfo = state.playInfo
    if(playInfo && playInfo.cupId === cupId) {
      playInfo.gameId = gameId
    } else {
      alert(JSON.stringify([cupId, gameId, playInfo]))
    }
  },
  [UPDATE_PLAY_KLINES](state, {
    gameId,
    kid,
    klines
  }) {
    const playInfo = state.playInfo
    if(playInfo && playInfo.gameId === gameId) {
      playInfo.kid = kid
      playInfo.klines = klines
    } else {
      // alert(JSON.stringify([gameId, kid, playInfo]))
    }
  },

  [UPDATE_MY_RANK](state, myRank) {
    state.myRank = myRank
  },
  [UPDATE_REALITY_RANKS](state, rankList) {
    state._rankList = rankList
  },
  [UPDATE_USERS](state, userList) {
    const userMap = state.userMap || {}
    forIn(userList, user => {
      userMap[user.uid] = user
    })
    state.userMap = userMap
  }
}
